module.exports = __webpack_public_path__ + "static/fibonacci-2f933d66dfe433d4547e4bfb8218779f.gif";